module.exports = __webpack_public_path__ + "i18n/en_8dd3dc3229010bf72d67e444d77fbb3b.json";


//////////////////
// WEBPACK FOOTER
// ./app/assets/i18n/en.json
// module id = aY29
// module chunks = 153